// extracted by mini-css-extract-plugin
export default {"block":"ui_block__rnfMW","iconWrapper":"ui_iconWrapper__r0Ywt","text":"ui_text__GBxr4"};